import { Box } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const BillContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(5, 3),
    borderRadius: 8,
    background: alpha(theme.palette.background.freshLight, 0.1),
}));
